import { render, staticRenderFns } from "./MyCorpsPieces.vue?vue&type=template&id=48872578&scoped=true"
import script from "./MyCorpsPieces.vue?vue&type=script&lang=js"
export * from "./MyCorpsPieces.vue?vue&type=script&lang=js"
import style0 from "./MyCorpsPieces.vue?vue&type=style&index=0&id=48872578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48872578",
  null
  
)

export default component.exports